import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-empty" }
const _hoisted_2 = { class: "container text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    hasClose: false,
    toggle: _ctx.toggle,
    "onUpdate:toggle": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toggle) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.notification.image,
            height: "59",
            width: "59"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: "description",
            innerHTML: _ctx.notification.description
          }, null, 8, _hoisted_4),
          _createElementVNode("button", {
            class: "btn btn-lg btn-primary btn-pd32 f-bold text-uppercase",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.notification.buttonText), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["toggle"]))
}